import styled from "styled-components";

export const Icon = styled.div`
    height: fit-content;
`;

export const Content = styled.div`
    padding-top: 0.5rem;
    font-size: ${globalThis.config.fonts.sizes.small};
    font-family: ${globalThis.config.fonts.families.light};
    height: fit-content;
`;

export const ErrorDetail = styled.div`
    color: ${globalThis.config.colors.grey2};
    font-size: ${globalThis.config.fonts.sizes.small};
    height: fit-content;
    p {
        margin: 0;
    }
`;

export const Header = styled.div`
    padding-top: 0.5rem;
    font-size: ${globalThis.config.fonts.sizes.xlarge};
    font-family: ${globalThis.config.fonts.families.medium};
    height: fit-content;
`;

export const Body = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`;

export const Footer = styled.div`
    padding-top: 0.5rem;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    text-align: left;
    padding: 4rem;
    position: relative;

    min-width: 28.25rem;
    width: 28.25rem;
    max-width: "28.25rem";

    min-height: 35.25rem;
    height: 35.25rem;
    max-height: 35.25rem;

    text-align: left;

    ${Header} {
        text-align: left;
    }
    ${Body} {
        text-align: left;
    }
    ${Footer} {
        text-align: left;
        justify-content: flex-end;
    }
`;

export const Buttons = styled.div`
    display: flex;
    margin-top: auto;
    gap: 1rem;
`;

export const CancelLink = styled.a`
    align-self: center;
`;

export const TryAgainButton = styled.button`
    width: 11rem;
    height: 2.8rem;
    align-self: center;
`;

export const EmailSupportButton = styled.button`
    width: 11rem;
`;

export const TestConnectionButton = styled.button`
    width: 11.75rem;
`;
